import React from 'react'
import Button from '../Button'

const CheckboxQuickFilter = ({ show, onSelect }) => {

	return (
		show
		?	<div style={{ position: 'absolute', top: 'calc(50% - 15px)', right: '0px', zIndex: 1000, textAlign: 'right' }}>
				<Button label='Only' onClick={ onSelect } color='primary' fullWidth={ false } size='small' >Only</Button>
			</div>
		:	null
	)
}

export default CheckboxQuickFilter